import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarOne = _resolveComponent("NavbarOne")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_StreetAddressesApartments = _resolveComponent("StreetAddressesApartments")!
  const _component_OurServices = _resolveComponent("OurServices")!
  const _component_BlastOff = _resolveComponent("BlastOff")!
  const _component_PoweringDailyLife = _resolveComponent("PoweringDailyLife")!
  const _component_WhyChooseUs = _resolveComponent("WhyChooseUs")!
  const _component_PartnerLogo = _resolveComponent("PartnerLogo")!
  const _component_PricingPlans = _resolveComponent("PricingPlans")!
  const _component_OurTestimonial = _resolveComponent("OurTestimonial")!
  const _component_OurLatestArticles = _resolveComponent("OurLatestArticles")!
  const _component_SubscribeContent = _resolveComponent("SubscribeContent")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarOne),
    _createVNode(_component_MainBanner),
    _createVNode(_component_StreetAddressesApartments),
    _createVNode(_component_OurServices),
    _createVNode(_component_BlastOff),
    _createVNode(_component_PoweringDailyLife),
    _createVNode(_component_WhyChooseUs),
    _createVNode(_component_PartnerLogo),
    _createVNode(_component_PricingPlans),
    _createVNode(_component_OurTestimonial),
    _createVNode(_component_OurLatestArticles, { class: "pt-100" }),
    _createVNode(_component_SubscribeContent),
    _createVNode(_component_MainFooter, { class: "bg-black" }),
    _createVNode(_component_CopyRight)
  ], 64))
}